import React, { useState } from 'react';
import { NavLinks } from '../../molecules';
import { NavLink } from '../../atoms';

/**
 * Navbar Organism Component
 * Main navigation bar combining logo, links, and actions
 */
const Navbar = ({ 
  logo = 'Pharma Outlet',
  logoTo = '/',
  links = [],
  activePath,
  onLinkClick,
  cartItemCount = 0,
  onCartClick,
  user = null,
  onLoginClick,
  onLogoutClick,
  className = '',
  ...props 
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`bg-white shadow-md ${className}`} {...props}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <NavLink 
              to={logoTo}
              href={logoTo}
              className="text-2xl font-bold text-blue-600 hover:bg-transparent hover:text-blue-700 px-0"
            >
              {logo}
            </NavLink>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <NavLink
              to="/"
              href="/"
              active={activePath === '/'}
              onClick={() => onLinkClick?.({ to: '/', label: 'Home' })}
            >
              Home
            </NavLink>
            <NavLink
              to="/products"
              href="/products"
              active={activePath === '/products'}
              onClick={() => onLinkClick?.({ to: '/products', label: 'Products' })}
            >
              Products
            </NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {mobileMenuOpen ? (
                <svg 
                  className="block h-6 w-6" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M6 18L18 6M6 6l12 12" 
                  />
                </svg>
              ) : (
                <svg 
                  className="block h-6 w-6" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M4 6h16M4 12h16M4 18h16" 
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-200">
            <NavLink
              to="/"
              href="/"
              active={activePath === '/'}
              onClick={() => {
                onLinkClick?.({ to: '/', label: 'Home' });
                setMobileMenuOpen(false);
              }}
              className="block"
            >
              Home
            </NavLink>
            <NavLink
              to="/products"
              href="/products"
              active={activePath === '/products'}
              onClick={() => {
                onLinkClick?.({ to: '/products', label: 'Products' });
                setMobileMenuOpen(false);
              }}
              className="block"
            >
              Products
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;

